import { Data } from './controller'
import ons from 'onsenui'

var SOTD = {
  oninit: (vnode) => {
    Data.sotd.fetch()
  },
  view: (vnode) => {
    if(!Data.sotd.result) {
      return m("ons-progress-bar[indeterminate]")
    } else {
      return m('p', m.trust(Data.sotd.result.html))
    }
  }
}

export default SOTD
